{
  "titles": {
    "appointmentDetailsHaveChanged": "预约详情已变更",
    "appointmentScheduled": "预约已安排",
    "appointmentConfirmed": "预约已确认",
    "appointmentRequested": "已申请预约",
    "missedAppointment": "错过预约",
    "recurringAppointmentSeriesCreated": "已创建重复预约系列",
    "truckArrivedAtFacility": "卡车已到达设施",
    "appointmentIsInProgressAtFacility": "预约正在设施中进行",
    "appointmentRescheduled": "预约已改期",
    "appointmentCompleted": "预约已完成",
    "appointmentCancelled": "预约已取消",
    "appointmentTagged": "预约已添加标签",
    "assetReadyForPickup": "资产待提货"
  },
  "subjects": {
    "appointmentDetailsHaveChanged": "预约详情已变更",
    "appointmentScheduled": "已在 {orgName} - {warehouseName} 安排预约",
    "appointmentConfirmed": "已在 {orgName} - {warehouseName} 确认预约",
    "appointmentRequested": "已在 {orgName} - {warehouseName} 申请预约",
    "missedAppointment": "错过了在 {orgName} - {warehouseName} 的预约",
    "recurringAppointmentSeriesCreated": "已创建重复预约系列",
    "truckArrivedAtFacility": "卡车已到达 {orgName} - {warehouseName}",
    "appointmentIsInProgressAtFacility": "在 {orgName} - {warehouseName} 的预约正在进行中",
    "appointmentRescheduled": "在 {orgName} - {warehouseName} 的预约已改期",
    "appointmentCompleted": "在 {orgName} - {warehouseName} 的预约已完成",
    "appointmentCancelled": "与 {orgName} - {warehouseName} 的预约已取消",
    "appointmentTagged": "预约已标记为 {tagName} - {warehouseName}",
    "assetReadyForPickup": "待提货 - 集装箱 {containerNumber}"
  },
  "subTitles": {
    "appointmentDetailsHaveChanged": "请核对以下地点、日期、时间及所有详情。",
    "appointmentScheduled": "请核对以下地点、日期、时间及所有详情。",
    "appointmentConfirmed": "请核对以下地点、日期、时间及所有详情。",
    "appointmentRequested": "请等待仓库确认。",
    "missedAppointment": "承运商未按预约到场。",
    "recurringAppointmentSeriesCreated": "请核对以下重复预约的详情。",
    "truckArrivedAtFacility": "请查看以下状态和预约详情。",
    "appointmentIsInProgressAtFacility": "请查看以下状态和预约详情。",
    "appointmentRescheduled": "请查看以下状态和预约详情。",
    "appointmentCompleted": "请查看以下状态和预约详情。",
    "appointmentCancelled": "请核对所有详情及取消原因。",
    "appointmentTagged": "请核对以下标签名称和信息。",
    "assetReadyForPickup": "您设施中的一项资产已准备好待提货。"
  },
  "anchorLabels": {
    "appointmentDetailsHaveChanged": "查看预约",
    "appointmentScheduled": "查看预约",
    "appointmentConfirmed": "查看预约",
    "appointmentRequested": "查看预约",
    "missedAppointment": "查看预约",
    "recurringAppointmentSeriesCreated": "查看原始预约",
    "truckArrivedAtFacility": "查看预约",
    "appointmentIsInProgressAtFacility": "查看预约",
    "appointmentRescheduled": "查看预约",
    "appointmentCompleted": "查看预约",
    "appointmentCancelled": "查看预约",
    "appointmentTagged": "查看预约",
    "assetReadyForPickup": "查看预约"
  },
  "descriptions": {
    "appointmentTagged": "使用“预约标签”设置单独启用标签"
  },
  "contextLabels": {
    "assetReadyForPickup": {
      "schedulingAnchorLabel": "预约提货",
      "idLabel": "确认号",
      "ownedByLabel": "所属方：",
      "pickupScheduledForLabel": "提货预约时间：",
      "noPickupScheduledLabel": "未安排提货预约",
      "storeLabel": "门店",
      "openInGoogleMapsLabel": "在 Google 地图中打开",
      "appointmentDetailsLabel": "预约详情",
      "loadTypeLabel": "货物类型",
      "warehouseInstructionsLabel": "仓库说明",
      "amenitiesLabel": "可用设施",
      "ppeRequirementsLabel": "个人防护装备及其他要求",
      "dockDoorLabel": "站台门",
      "dockInstructionsLabel": "站台说明",
      "carrierContactLabel": "承运商联系人"
    }
  }
}
